import { render, staticRenderFns } from "./LeagueMenu.vue?vue&type=template&id=8fe91162&scoped=true&"
import script from "./LeagueMenu.vue?vue&type=script&lang=js&"
export * from "./LeagueMenu.vue?vue&type=script&lang=js&"
import style0 from "./LeagueMenu.vue?vue&type=style&index=0&id=8fe91162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe91162",
  null
  
)

export default component.exports